forms-comments-reply
  form.form(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.method")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.authenticity_token")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.parent_id")
    inputs-complex-comment-textarea(tag-scope="{ this.tagScope }.inputs.content")
  script(type="typescript").
    this.mixin('forms.comments.reply')
